import dayjs from "dayjs";

const formatDateTime = timestamp => {
  const now = dayjs();
  const msgTime = dayjs(timestamp);
  const diffMinutes = now.diff(msgTime, "minute");
  const diffHours = now.diff(msgTime, "hour");
  const diffDays = now.diff(msgTime, "day");

  if (diffMinutes < 1) return "Just now";
  if (diffMinutes < 60) return `${diffMinutes}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays === 1) return "Yesterday";
  if (diffDays < 7) return `${diffDays}d ago`;
  return msgTime.format("MMM D YYYY");
};

export default formatDateTime;
